/**
 * /onboarding/invited — the INVITED person's arrival tutorial (route shell).
 *
 * Reached immediately after an invited teammate or trustee sets their password
 * (`routes/auth/reset-password.tsx`, the accept-invite branch) — and, for firm
 * staff, after the MFA enrolment that gate insists on first. It is the screen
 * that replaces "you are now looking at a console nobody explained".
 *
 * The screen itself lives in `./invited-screen.tsx` and is lazy-loaded via
 * `lazyRouteComponent`, exactly like the sibling `/onboarding/firm` and
 * `/onboarding/individual` shells: this is a deliberate destination reached once
 * per account, so its copy has no business sitting in the entry bundle.
 *
 * ⚠️ Hand-added to `routeTree.gen.ts` mirroring those two siblings. The router
 * plugin is NOT in vite.config — the generated tree is maintained by hand here,
 * and only `pnpm build` catches a mismatch between this file and that one.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/onboarding/invited')({
  component: lazyRouteComponent(() => import('./invited-screen'), 'OnboardingInvitedScreen'),
});
